import React from 'react';
import { Box, Grid } from '@mui/material';
import { Task } from '../../types';
import { TaskList } from './TaskList';
import { TaskSummary } from './TaskSummary';

interface CaseDetailsContentProps {
  tasks: Task[];
  stageId: string;
  onTaskUpdate: (taskId: string, updates: Partial<Task>) => void;
  onTaskCreate: (task: Partial<Task>) => void;
  onFormOpen?: (task: Task) => void;
}

export const CaseDetailsContent: React.FC<CaseDetailsContentProps> = ({
  tasks,
  stageId,
  onTaskUpdate,
  onTaskCreate,
  onFormOpen,
}) => {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <TaskList 
            tasks={tasks}
            stageId={stageId}
            onTaskUpdate={onTaskUpdate}
            onTaskCreate={onTaskCreate}
            onFormOpen={onFormOpen}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TaskSummary tasks={tasks} />
        </Grid>
      </Grid>
    </Box>
  );
};